<template>
    <div :class="null == titleText ? 'img-view' : 'img-view'">
        <div v-if="null != titleText" class="title-text-box">
            <span>{{titleText}}</span>

            <div v-if="null != buttonText">
                <el-button size="large" type="success" @click="clickBtn">
                    <span>{{buttonText}}</span>
                </el-button>
            </div>

        </div>

        <div style="position: absolute; top: 10px; right: 10px">
            <el-button type="danger" size="large" circle @click="clickClose">
                <font-awesome-icon icon="fa-solid fa-xmark" />
            </el-button>
        </div>

        <img :src="imgUrl" style="width: 100%; height: 100%; object-fit: contain">
    </div>
</template>

<script setup>
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faXmark } from '@fortawesome/free-solid-svg-icons'
    import {inject} from "vue";

    library.add(faXmark)

    const props = defineProps(["imgUrl", "titleText", "buttonText"])
    const emits = defineEmits(["clickClose", "clickBtn"])

    const i18n = inject("i18n")

    function clickClose() {
        emits("clickClose")
    }

    function clickBtn() {
        emits("clickBtn")
    }

</script>

<style scoped>
    .img-view {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        padding: 20px;
        box-sizing: border-box;
        background-color: #a6a6a6e8;
    }

    .with-text-img-view {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        padding: 20px;
        box-sizing: border-box;
        background-color: #a6a6a6e8;
        padding-top: 50px;
    }

    .title-text-box {
        position: absolute;
        bottom: 50px;
        left: 0;
        width: 100%;
        text-align: center;
        line-height: 30px;
        font-size: 18px;
        color: #fefefe;
        font-weight: 600;
    }
</style>